<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="工厂:">
                <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择工厂">
                    <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryDesc" :value="item.factoryCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="采购组织:">
                <el-select v-model="dataForm.ekorg" filterable clearable placeholder="请选择组织">
                    <el-option v-for="item in purchaseOrgList" :key="item.purchaseOrgCode" :label="item.purchaseOrgName" :value="item.purchaseOrgCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                </el-table-column>
                <el-table-column prop="zguid" header-align="center" align="left" label="32位唯一标识:" width="270">
                </el-table-column>
                <el-table-column prop="zsrmh" header-align="center" align="left" label="SRM协议号" width="160">
                </el-table-column>
                <el-table-column prop="choose" header-align="center" align="center" label="OPTION" width="100">
                    <template slot-scope="scope">
                        {{CHOOSE_TYPE(scope.row.choose)}}
                    </template>
                </el-table-column>
                <el-table-column prop="lifnr" header-align="center" align="center" label="供应商帐户号" width="130">
                </el-table-column>
                <el-table-column prop="werks" header-align="center" align="left" label="工厂" width="300">
                    <template slot-scope="scope">
                        <span>{{getFactoryName(scope.row.werks)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="matnr" header-align="center" align="left" label="物料号" width="150">
                </el-table-column>
                <el-table-column prop="ekgrp" header-align="center" align="center" label="采购组" width="100">
                </el-table-column>
                <el-table-column prop="ekorg" header-align="center" align="left" label="采购组织" width="300">
                    <template slot-scope="scope">
                        <span>{{getPurchaseOrgName(scope.row.ekorg)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="esokz" header-align="center" align="center" label="采购信息记录分类" width="120">
                    <template slot-scope="scope">
                        {{ESOKZ_TYPE(scope.row.esokz)}}
                    </template>
                </el-table-column>
                <el-table-column prop="verkf" header-align="center" align="center" label="责任销售员" width="100">
                </el-table-column>
                <el-table-column prop="telf1" header-align="center" align="left" label="供应商电话号码" width="150">
                </el-table-column>
                <el-table-column prop="meins" header-align="center" align="center" label="采购单位" width="100">
                </el-table-column>
                <el-table-column prop="aplfz" header-align="center" align="center" label="计划交货天数" width="100">
                </el-table-column>
                <el-table-column prop="mwskz" header-align="center" align="center" label="税码" width="100">
                    <template slot-scope="scope">
                        {{getTaxCodeName(scope.row.mwskz)}}
                    </template>
                </el-table-column>
                <el-table-column prop="netpr" header-align="center" align="right" label="净价(不含税价格)" width="120">
                </el-table-column>
                <el-table-column prop="waers" header-align="center" align="center" label="币别" width="80">
                </el-table-column>
                <el-table-column prop="peinh" header-align="center" align="center" label="价格单位" width="80">
                </el-table-column>
                <el-table-column prop="bpumz" header-align="center" align="center" label="转换分子" width="80">
                </el-table-column>
                <el-table-column prop="bpumn" header-align="center" align="center" label="转换分母" width="80">
                </el-table-column>
                <el-table-column prop="kosrt" header-align="center" align="center" label="是否暂估" width="80">
                    <template slot-scope="scope">
                        {{KOSRT_TYPE(scope.row.kosrt)}}
                    </template>
                </el-table-column>
                <el-table-column prop="datab" header-align="center" align="left" label="开始生效日期" width="150" :formatter="dateFormat" >
                </el-table-column>
                <el-table-column prop="datbi" header-align="center" align="left" label="有效截至日期" width="150" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="left" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>

                <el-table-column header-align="center" align="left" label="操作" width="190" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    fetchPurchaseRoutePriceList,
    deletePurchaseRoutePrice,
    getFactoryList,
    getPurchaseOrgList,
    getTaxCodeList
} from '@/controller/systemData'
import {
    CHOOSE_TYPE,
    getChooseByValue,
    getEsokzByValue,
    getKosrtByValue
} from "@/utils/const";
import AddOrUpdate from './purchaseRoutePrice-add-or-update'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            getChooseByValue: getChooseByValue,
            dataForm: {
                werks: '',
                ekorg: '',
            },
            dataList: [],
            CHOOSE_TYPE: getChooseByValue,
            ESOKZ_TYPE: getEsokzByValue,
            KOSRT_TYPE: getKosrtByValue,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    components: {
        AddOrUpdate
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },
    activated() {
        this.getDataList()
        this.getFactoryList()
        // 采购组织
        this.getPurchaseOrgList()
        // 税码
        this.getTaxCodeList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        // 下拉输入采购组织
        getPurchaseOrgList() {
            getPurchaseOrgList({
                purchaseOrgCode: "",
                purchaseOrgName: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.purchaseOrgList = data.body;
                }
            });
        },
        getPurchaseOrgName(code) {
            const purchaseOrg = this.purchaseOrgList.find(purchaseOrg => purchaseOrg.purchaseOrgCode === code)
            return purchaseOrg ? purchaseOrg.purchaseOrgName : ''
        },
        // 下拉输入税码
        getTaxCodeList() {
            getTaxCodeList({
                taxCode: "",
                taxRate: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            });
        },
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            fetchPurchaseRoutePriceList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'werks': this.dataForm.werks,
                'ekorg': this.dataForm.ekorg,
            }).then(data => {
                console.log(data, 'data')
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // OPTION(C 新建/U修改)
        chooseFormat: function (value) {
            if (!value) {
                return "";
            }
            return getChooseByValue(CHOOSE_TYPE, value);
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        viewHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            console.log(row)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deletePurchaseRoutePrice({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
